import { Drawer } from 'antd';
import layoutStorage from "../storages/layout-storage";
import { observer } from "mobx-react-lite";
import { SelectBrandDialog } from "./select-brand-dialog";
import AddPartForm from "../forms/add-part-form";
import { AddPartTypeDialog } from "./add-part-type-dialog";
import { useState } from "react";
import itemsStorage from "../storages/items-storage";
import * as RestApi from '../helpers/rest-api-query';
import { IBrand } from "@drone-parts.garphild.pro/interfaces";

export function AddDronePartDialog() {
  const [brand, selectBrand] = useState<IBrand['_id']>('');
  const [partType, selectPartType] = useState<string[]>([]);
  const [name, setName] = useState<string>('');
  const [description, setDescription] = useState<string>('');
  const [isAddMore, setIsAddMore] = useState<boolean>(false);
  const [officialUrl, setOfficialUrl] = useState<string>('');
  const [officialPrice, setOfficialPrice] = useState<number>(0);
  const [expired, setExpired] = useState<boolean>(false);

  const {
    toggleAddPartModalDialog,
    isAddPartModalOpen,
    isSelectBrandDialogOpened,
    toggleSelectBrandDialog,
    isAddPartTypeModalOpened,
    toggleAddPartTypeModalDialog,
  } = layoutStorage;

  const setBrand = (brandId: IBrand['_id']) => {
    selectBrand(brandId);
    toggleSelectBrandDialog();
  }

  const setPartType = () => {
    toggleAddPartTypeModalDialog();
  }

  const onSubmit = () => {
    RestApi.post('/api/item', {
      id: 0,
      brandId: brand,
      partTypeId: partType,
      name,
      description,
      officialUrl,
      officialPrice,
      expired,
    })
      .then(() => {
        selectBrand('');
        selectPartType([]);
        setName('');
        setDescription('');
        setOfficialUrl('');
        setOfficialPrice(0);
        setExpired(false);

        if (!isAddMore) {
          toggleAddPartModalDialog();
        }
        itemsStorage.loadItems();
      });
  }

  return (
    <Drawer
      title="Add part"
      width={520}
      closable={true}
      onClose={toggleAddPartModalDialog}
      open={isAddPartModalOpen}
    >
      <AddPartForm
        brand={brand}
        partType={partType}
        name={name}
        description={description}
        isAddMore={isAddMore}
        officialUrl={officialUrl}
        officialPrice={officialPrice}
        expired={expired}
        setOfficialPrice={setOfficialPrice}
        selectBrand={selectBrand}
        selectPartType={selectPartType}
        setName={setName}
        setDescription={setDescription}
        setIsAddMore={setIsAddMore}
        setOfficialUrl={setOfficialUrl}
        setExpired={setExpired}
        onSubmit={() => {
          onSubmit();
        }}
      />
      <SelectBrandDialog
        opened={isSelectBrandDialogOpened}
        onToggle={toggleSelectBrandDialog}
        onSelect={setBrand}
      />
      <AddPartTypeDialog
        parentKey={""}
        opened={isAddPartTypeModalOpened}
        onToggle={toggleAddPartTypeModalDialog}
        onSelect={setPartType}
      />
    </Drawer>
  );
}

export default observer(AddDronePartDialog);
